var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
var AddNewButton = /** @class */ (function () {
    function AddNewButton(container, data, deletePromtText) {
        if (container == null)
            return;
        this.button = container.querySelector('#subscription-add');
        this.input = container.querySelector('#subscription-add-input');
        this.fieldsetContainer = container.querySelector('.subscription-field-container');
        this.data = data;
        this.deletePromtText = deletePromtText;
        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.input.setAttribute('pattern', data.regex.toString().replace(/^\/*/, '').replace(/\/*$/, ''));
    }
    AddNewButton.prototype.onButtonClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.input.checkValidity() && this.input.value.match(this.data.regex))) return [3 /*break*/, 6];
                        this.input.disabled = true;
                        this.button.disabled = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("/wp-json/fr_agilis/v1/template/".concat(this.data.type, "/").concat(this.input.value))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = (_a.sent());
                        if (json.error) {
                            alert(json.error);
                        }
                        else if (json.data) {
                            this.initializeNewFieldset(json.data);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        this.input.value = '';
                        this.input.disabled = false;
                        this.button.disabled = false;
                        return [3 /*break*/, 7];
                    case 6:
                        alert(this.data.errorMessage);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AddNewButton.prototype.initializeNewFieldset = function (data) {
        var _this = this;
        var parser = new DOMParser();
        var document = parser.parseFromString(data, 'text/html');
        var fieldset = document.body.querySelector('body > fieldset');
        fieldset.querySelectorAll('button.subscription-entry-edit').forEach(function (it) { return new EditButton(it); });
        fieldset.querySelectorAll('button.subscription-entry-delete').forEach(function (it) { return new DeleteButton(it, _this.deletePromtText); });
        // expand body
        fieldset.querySelectorAll('.subscription-entry-body').forEach(function (it) { return it.classList.remove('hidden'); });
        // show note
        fieldset.querySelectorAll('.subscription-entry-note-no-subs').forEach(function (it) { return it.classList.remove('hidden'); });
        this.fieldsetContainer.appendChild(fieldset);
    };
    return AddNewButton;
}());
export default AddNewButton;
